import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Button } from "@mui/material";
import client from "../../../Common/Client/Client";
import UnlockSelect from "./UnlockSelect";

const Unlock = () => {
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [selectedSeat, setSelectedSeat] = useState([]);
  const [layout, setLayout] = useState([]);
  const [isPending, setIsPending] = useState(false);

  const seatLockData = async () => {
    setIsPending(true);
    const dateObj = new Date(selectedDate);
    const day = String(dateObj.getUTCDate()).padStart(2, "0");
    const month = String(dateObj.getUTCMonth() + 1).padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const formatDate = `${day}/${month}/${year}`;

    try {
      const response = await client.get(`/admin-lock/lock?date=${formatDate}`, {
        withCredentials: true,
      });
      if (response.status === 200) {
        const lockedSeatId = response?.data?.lockedSeat
          ? response?.data?.lockedSeat.bookings.reduce((acc, curr) => {
              if (curr.admin === true) {
                acc.push(curr.id);
              }

              return acc;
            }, [])
          : [];
        setSelectedSeat(lockedSeatId);
        setLayout(response?.data?.seatLayout);
        setIsPending(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    seatLockData();
  }, [selectedDate]);

  return (
    <>
      <main id="main">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">Admin Seat Lock</li>
            </ol>
          </nav>
        </div>
        <section>
          <div className="card" style={{ width: "100%" }}>
            <div style={{ padding: "20px" }}>
              <h5
                className="card-title"
                style={{ textAlign: "center", marginBottom: "20px" }}
              >
                Seat Unlock
              </h5>
              <div className="row">
                <div className="col-md-6 mt-3">
                  <div>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Select Travel Date"
                        value={selectedDate}
                        format="DD/MM/YYYY"
                        onChange={(newValue) => {
                          setSelectedDate(newValue);
                        }}
                        slotProps={{ textField: { fullWidth: true } }}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                <div className="col-md-6 mt-3">
                  <UnlockSelect
                    layout={layout}
                    selectedSeat={selectedSeat}
                    selectedDate={selectedDate}
                    seatLockData={seatLockData}
                    isPending={isPending}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Unlock;
